import { Button, CircularProgress } from '@mui/material'
import { resetLoginAttempts } from 'global-apis/nexus-service-cqe'
import React, { useState } from 'react'
import { useCustomerContext } from '../CustomerContext'
import { useTheme } from '../../../utils/themeContext'
import { getColorsForTheme } from '../../../global-styles/clientColors'

export function ResetLoginAttemptsButton() {
  const { customerId, customerInfo } = useCustomerContext()
  const [loading, setLoading] = useState(false)
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)
  
  const handleOnClick = async () => {
    const { accountNumber, phone } = customerInfo
    setLoading(true)

    try {
      await resetLoginAttempts({
        accountNumber,
        customerId,
        phoneNumber: `+1${phone.replace(/\D/g, '')}`,
      })
    } catch (error) {
      console.error('Error:', error)
    }

    setLoading(false)
  }

  return (
    <div>
      <Button
        color="error"
        disabled={loading}
        onClick={handleOnClick}
        type="button"
        variant="contained"
        sx={{
          backgroundColor: 'error.main',
          color: 'white',
          '&:hover': {
            backgroundColor: 'error.dark',
          },
          // For Galpin theme, override with silver when not error state
          ...(currentTheme === 'galpin' && {
            backgroundColor: themeColors.buttonColor,
            color: 'black',
            '&:hover': {
              backgroundColor: themeColors.buttonHover,
            },
          }),
        }}
      >
        Reset Login Attempts{' '}
        {loading && <CircularProgress sx={{ marginLeft: 1 }} size={20} />}
      </Button>
    </div>
  )
}
